import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import PaginaBase from "./pages/PaginaBase";
import PaginaInicial from "./pages/PaginaInicial";
import SoliciteProposta from "./pages/SoliciteProposta";
import Sobre from "./pages/Sobre";

function AppRoutes() {
    return (
        <BrowserRouter>
        <Routes>
            <Route path="/" element={<PaginaBase />}>
            <Route index element={<PaginaInicial />} />
            <Route path="/solicite-proposta" element={<SoliciteProposta />} />
            <Route path="/sobre" element={<Sobre />} />
            {/* <Route path="/dashboard" element={<Dashboard />} /> */}
            </Route>
        </Routes>
        </BrowserRouter>
    )
}

export default AppRoutes;